import React from 'react';
import type { QuickLink } from '@app-types/performanceTrends';
import { postSectionJumpMessage } from '@utils/widgetMessages';

export interface TrendsQuickLinksProps {
  links: QuickLink[];
  nodeId?: string;
}

/**
 * Quick links row (Figma 3158:5213). Red underlined links, no text caret.
 * Styles live in PerformanceTrendsPage.less (.performance-trends__quick-links).
 */
const TrendsQuickLinks: React.FC<TrendsQuickLinksProps> = ({ links, nodeId }) => (
  <nav className="performance-trends__quick-links" aria-label="クイックリンク" data-node-id={nodeId}>
    {links.map((link) => (
      <a
        key={link.key}
        href={link.href}
        className="performance-trends__quick-link"
        data-node-id={link.nodeId}
        onClick={(event) => {
          if (
            event.defaultPrevented || event.button !== 0 ||
            event.ctrlKey || event.metaKey || event.shiftKey || event.altKey ||
            !link.href.startsWith('#')
          ) return;

          if (postSectionJumpMessage(link.href.slice(1))) event.preventDefault();
        }}
      >
        {link.label}
      </a>
    ))}
  </nav>
);

export default TrendsQuickLinks;
